import Swiper from "https://unpkg.com/swiper@8/swiper-bundle.esm.browser.min.js";

const init = ({ el }) => {
  const context = el;
  const elements = {
    carousel: context.querySelector("[data-stocked-by-carousel-carousel]"),
    slides: context.querySelectorAll("[data-stocked-by-carousel-slide]"),
    wrapper: context.querySelector(".stocked-by-carousel__wrapper"),
  };

  if (elements.slides.length > 0) {
    const swiper = new Swiper(elements.carousel, {
      direction: "horizontal",
      loop: true,
      grabCursor: false,
      slidesPerView: "auto",
      freeMode: true,
      freeModeFluid: true,
      freeModeMomentum: false,
      centeredSlides: false,
      speed: 5000,
      simulateTouch: false,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
      spaceBetween: 32
    });

    if (elements.wrapper && swiper.autoplay) {
      elements.wrapper.addEventListener("mouseenter", () => {
        swiper.autoplay.stop();
      });

      elements.wrapper.addEventListener("mouseleave", () => {
        swiper.autoplay.start();
      });
    }
  }
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-module='stocked-by-carousel']").forEach((el) => {
    init({ el });
  });
});

